import { connect } from 'react-redux';
import { getActiveType } from '../selectors';

const mapStateToProps = state => ({
  type: getActiveType(state),
});

export default connect(mapStateToProps);
